import { render, staticRenderFns } from "./LinkListTwo.vue?vue&type=template&id=6c8a68b8&scoped=true&"
import script from "./LinkListTwo.vue?vue&type=script&lang=js&"
export * from "./LinkListTwo.vue?vue&type=script&lang=js&"
import style0 from "./LinkListTwo.vue?vue&type=style&index=0&id=6c8a68b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a68b8",
  null
  
)

export default component.exports